import { IntegrationDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useIntegrationDelete = (integrationId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `integration/${integrationId}`,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as IntegrationDeleteResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Integrations],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Integrations],
      });
      queryClient.resetQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SellarIntegration],
      });
    },
  });
};
